import React from "react";
import { Button, Dropdown, Grid } from "semantic-ui-react";
import pencil from "../../../assets/icons/edit-pencil-hover-icon.svg";
import trashHoverIcon from "../../../assets/icons/trash-hover-icon.svg";
import approveIconToggle from "../../../assets/icons/toggle-off-icon.svg";
import approvedIconToggle from "../../../assets/icons/toggle-on-icon.svg";
import previewHoverIcon from "../../../assets/icons/preview-hover-icon.svg";
import repostHoverIcon from "../../../assets/icons/repost-hover-icon.svg";
import statsHoverIcon from "../../../assets/icons/stats-icon-hover.svg";
import avatar from "../../../assets/icons/seethru-avatar.svg";
import { useDispatch, useSelector } from "react-redux";
import { closeModal, openModal } from "../../../app/common/modals/modalReducer";
import {
  ADMIN_JOB_CLOSE_MODAL,
  ADMIN_JOB_REVIEW_MODAL,
  DELETE_JOB_CONFIRM_MODAL,
  EDIT_JOB_MODAL,
  JOB_DETAILS_MODAL,
  STANDARD_MODAL,
} from "../../../app/common/modals/ModalManager";
import { JOB_POST_TYPE } from "../employerConstanst";
import { useHistory } from "react-router-dom";
import { EMPLOYER_DASHBOARD_POST_JOB_PATH } from "../../../app/api/routeConstants";
import {
  selectedEmployerDraftJob,
  selectedEmployerRepostJob,
} from "../employerActions";
import omit from "lodash/omit";
import ListActionIcon from "../../../app/common/components/ListActionIcon";
import { isItemExpired } from "../../jobs/helpers/compareJobDates";
import { differenceInCalendarDays } from "date-fns";
import {
  getDraftJobSavedDate,
  getItemExpiredDate,
  getItemPublishedDate,
  getJobSubmittedDate,
} from "../../../js/helpers/getItemDisplayDate";
import ApplicantsPane from "../../candidates/components/ApplicantsPane";
import JobStatsPane from "../../dashboards/components/JobStatsPane";
import ReactGA from "react-ga4";
import { HR_HEALTHCARE_MODE } from "../../modes/constants";
import { isMultiLocJob } from "../../../js/helpers/multipleJobLocationHelpers";

export const MANAGE_EDIT_BUTTON = "MANAGE_EDIT_BUTTON";
export const MANAGE_VIEW_BUTTON = "MANAGE_VIEW_BUTTON";
export const MANAGE_STATS_BUTTON = "MANAGE_STATS_BUTTON";
export const MANAGE_APPLICANTS_BUTTON = "MANAGE_APPLICANTS_BUTTON";
export const MANGE_REPOSTS_BUTTON = "MANGE_REPOSTS_BUTTON";

export default function JobPostListItem({
  job,
  editable,
  deletable,
  preview,
  repost,
  stats,
  applicants,
  handleSetApplicantsView,
  handleSetStatsView,
  type,
  close,
  isAdmin = false,
  mainButton = "",
  isShowMenu = true,
}) {
  const dispatch = useDispatch();
  const history = useHistory();

  const { responsive } = useSelector((state) => state.app);
  const { isCookieConsent } = useSelector((state) => state.app);

  function getJobDisplayDate(jobType) {
    if (jobType === JOB_POST_TYPE.expired) {
      return getItemExpiredDate(job);
    } else if (jobType === JOB_POST_TYPE.underReview) {
      return getJobSubmittedDate(job);
    } else if (jobType === JOB_POST_TYPE.current) {
      return getItemPublishedDate(job);
    } else if (jobType === JOB_POST_TYPE.draft) {
      return getDraftJobSavedDate(job);
    }
  }

  function handleEditClick() {
    if (type === JOB_POST_TYPE.draft) {
      dispatch(selectedEmployerDraftJob({ ...job, dateCreated: "" }));
      history.push(EMPLOYER_DASHBOARD_POST_JOB_PATH);
    } else {
      dispatch(
        openModal({
          modalType: EDIT_JOB_MODAL,
          modalProps: { job },
        })
      );
    }
  }

  function handleViewClick() {
    dispatch(
      openModal({
        modalType: JOB_DETAILS_MODAL,
        modalProps: { job },
      })
    );
  }

  function handleRepostClick() {
    const jobToRepost = {
      ...omit(job, [
        "id",
        "employerId",
        "refNumber",
        "isApproved",
        "isClosed",
        "isInitialised",
        "isActive",
        "isStandardService",
        "isExpressService",
        "isSponsoredPromotion",
        "isFeaturedPromotion",
        "isSocialMediaPromotion",
        "adminKeywords",
        "keywords",
        "dateFeaturedExpiring",
        "dateSponsoredExpiring",
        "datesSponsoredFor",
        "datesFeaturedFor",
        "dateCreated",
        "dateExpiring",
        "datePublished",
        "dateClosed",
        "isLocationHidden",
        "isFree",
        "isPaidFor",
        "companyRefName",
        "multipleLocations",
        "isMultipleLocations",
        "jobId",
      ]),
    };
    dispatch(selectedEmployerRepostJob({ ...jobToRepost, dateExpiring: "" }));
    history.push(EMPLOYER_DASHBOARD_POST_JOB_PATH);
  }

  function handleApplicantsClick() {
    if (isAdmin) {
      dispatch(
        openModal({
          modalType: STANDARD_MODAL,
          modalProps: {
            component: (
              <ApplicantsPane
                job={job}
                handleBackToManage={() => dispatch(closeModal())}
              />
            ),
          },
        })
      );
    } else {
      if (isCookieConsent) {
        ReactGA.event({
          category: "Button",
          action: "Applicants pane - Employer",
        });
      }
      handleSetApplicantsView(job);
    }
  }

  function handleStatsClick() {
    if (isAdmin) {
      dispatch(
        openModal({
          modalType: STANDARD_MODAL,
          modalProps: {
            component: (
              <JobStatsPane
                job={job}
                handleBackToManage={() => dispatch(closeModal())}
              />
            ),
          },
        })
      );
    } else {
      if (isCookieConsent) {
        ReactGA.event({
          category: "Button",
          action: "Job stats pane - Employer",
        });
      }
      handleSetStatsView(job);
    }
  }

  function getExpiredJobStatus(job) {
    return job.isClosed ? "Closed" : "Pending";
  }

  function EditButton({ isMenu = false }) {
    if (isMenu) {
      return (
        <Dropdown.Item onClick={handleEditClick}>
          <Button
            className={"overwrite-button icon-text-button"}
            content={"Edit"}
            icon={
              <img
                className={"icon-text-button-img"}
                src={pencil}
                style={{ width: 17, height: 12 }}
                alt="edit"
              />
            }
          />
        </Dropdown.Item>
      );
    } else {
      return (
        <Button
          className={"overwrite-button icon-text-button"}
          content={<span className={"action-text"}>Edit</span>}
          icon={
            <img
              className={"icon-text-button-img"}
              src={pencil}
              style={{ width: 17, height: 12 }}
              alt="edit"
            />
          }
          onClick={handleEditClick}
          style={{ margin: "0 15px 0 0" }}
        />
      );
    }
  }

  function ApplicantsButton({ isMenu = false }) {
    if (isMenu) {
      return (
        <Dropdown.Item onClick={handleApplicantsClick}>
          <Button
            className={"overwrite-button icon-text-button"}
            content={"Applicants"}
            icon={
              <img
                className={"icon-text-button-img"}
                src={avatar}
                style={{ width: 16, height: 16 }}
                alt="edit"
              />
            }
          />
        </Dropdown.Item>
      );
    } else {
      return (
        <Button
          className={"overwrite-button icon-text-button"}
          content={<span className={"action-text"}>Applicants</span>}
          icon={
            <img
              className={"icon-text-button-img"}
              alt="avatar"
              src={avatar}
              style={{ width: 16, height: 16 }}
            />
          }
          onClick={handleApplicantsClick}
          style={{ margin: "0 15px 0 0" }}
        />
      );
    }
  }

  function StatsButton({ isMenu = false }) {
    if (isMenu) {
      return (
        <Dropdown.Item onClick={handleStatsClick}>
          <Button
            className={"overwrite-button icon-text-button"}
            content={"Statistics"}
            icon={
              <img
                className={"icon-text-button-img"}
                src={statsHoverIcon}
                style={{ width: 17, height: 14 }}
                alt="stats"
              />
            }
          />
        </Dropdown.Item>
      );
    } else {
      return (
        <Button
          className={"overwrite-button icon-text-button"}
          content={<span className={"action-text"}>Statistics</span>}
          icon={
            <img
              className={"icon-text-button-img"}
              alt="stats"
              src={statsHoverIcon}
              style={{ width: 17, height: 14 }}
            />
          }
          onClick={handleStatsClick}
          style={{ margin: "0 15px 0 0" }}
        />
      );
    }
  }

  function ViewButton({ isMenu = false }) {
    if (isMenu) {
      return (
        <Dropdown.Item onClick={handleViewClick}>
          <Button
            className={"overwrite-button icon-text-button"}
            content={"View"}
            icon={
              <img
                className={"icon-text-button-img"}
                src={previewHoverIcon}
                style={{ width: 20, height: 15.3 }}
                alt={"view"}
              />
            }
          />
        </Dropdown.Item>
      );
    } else {
      return (
        <Button
          className={"overwrite-button icon-text-button"}
          content={<span className={"action-text"}>View</span>}
          icon={
            <img
              className={"icon-text-button-img"}
              src={previewHoverIcon}
              style={{ width: 20, height: 15.3 }}
              alt="view"
            />
          }
          onClick={handleViewClick}
          style={{ margin: "0 15px 0 0" }}
        />
      );
    }
  }

  function RepostButton({ isMenu = false }) {
    if (isMenu) {
      return (
        <Dropdown.Item onClick={handleRepostClick}>
          <Button
            className={"overwrite-button icon-text-button"}
            content={"Repost"}
            icon={
              <img
                className={"icon-text-button-img"}
                src={repostHoverIcon}
                alt="repost"
                style={{ width: 15, height: 15 }}
              />
            }
          />
        </Dropdown.Item>
      );
    } else {
      return (
        <Button
          className={"overwrite-button icon-text-button"}
          content={<span className={"action-text"}>Repost</span>}
          icon={
            <img
              className={"icon-text-button-img"}
              src={repostHoverIcon}
              alt="repost"
              style={{ width: 15, height: 15 }}
            />
          }
          onClick={handleRepostClick}
          style={{ margin: "0 15px 0 0" }}
        />
      );
    }
  }

  return (
    <div
      className="job-list-item body-blue-text"
      style={
        isAdmin && job.mode === HR_HEALTHCARE_MODE
          ? { border: "1px solid #80bf7c" }
          : {}
      }
    >
      <Grid style={{ paddingRight: 14 }} stackable>
        <Grid.Column
          width={type === JOB_POST_TYPE.expired ? 5 : 4}
          verticalAlign="middle"
          textAlign="left"
          style={{ padding: 12 }}
        >
          {type === JOB_POST_TYPE.expired && (
            <span className="italic-text" style={{ marginRight: 8 }}>
              {getExpiredJobStatus(job)}
            </span>
          )}
          <span>{getJobDisplayDate(type)}</span>
        </Grid.Column>
        <Grid.Column
          width={type !== JOB_POST_TYPE.expired ? 7 : 6}
          verticalAlign="middle"
          style={{ padding: 12 }}
        >
          <span>{job.title}</span>
          {job.isFree && (
            <span className="accent-colour" style={{ marginLeft: 7 }}>
              (Free)
            </span>
          )}
          {isAdmin && (
            <span className="pink" style={{ marginLeft: 7 }}>
              {job.isStandardService && "Standard "}
              {job.isExpressService && "Express "}
              {job.isTemporaryShiftService && "Temp shift "}
              {job.id}
            </span>
          )}
          {isAdmin && (
            <span style={{ marginLeft: 3, color: "purple" }}>
              {job.isMultipleLocations &&
                !isMultiLocJob(job.employerId) &&
                "ML1"}
              {job.isMultipleLocations &&
                isMultiLocJob(job.employerId) &&
                "ML+"}
            </span>
          )}
        </Grid.Column>
        <Grid.Column
          width={5}
          verticalAlign="middle"
          textAlign={responsive.isComputer ? "right" : "left"}
          style={{ padding: 12 }}
        >
          {isAdmin &&
            close &&
            (isItemExpired(job) ||
              differenceInCalendarDays(job.dateExpiring, new Date()) === 0) &&
            !job.isClosed && (
              <ListActionIcon
                dataTestId="close-icon-testid"
                action={() =>
                  dispatch(
                    openModal({
                      modalType: ADMIN_JOB_CLOSE_MODAL,
                      modalProps: { job },
                    })
                  )
                }
                semanticIcon={"file alternate outline"}
                alt="repost"
                text="Close"
              />
            )}
          {isAdmin && !isMultiLocJob(job.employerId) && (
            <span
              className="job-list-item-action-icon clickable"
              data-testid={
                job.isApproved
                  ? "admin-approved-button-testid"
                  : "admin-approve-button-testid"
              }
              onClick={() =>
                dispatch(
                  openModal({
                    modalType: ADMIN_JOB_REVIEW_MODAL,
                    modalProps: { job },
                  })
                )
              }
            >
              <img
                style={{ width: 41, height: 18.3 }}
                src={job.isApproved ? approvedIconToggle : approveIconToggle}
                alt="toggle icon"
              />
            </span>
          )}
          {repost && !isAdmin && mainButton === MANGE_REPOSTS_BUTTON && (
            <RepostButton isMenu={false} />
          )}
          {applicants &&
            job.isInitialised &&
            mainButton === MANAGE_APPLICANTS_BUTTON && <ApplicantsButton />}
          {stats && job.isInitialised && mainButton === MANAGE_STATS_BUTTON && (
            <StatsButton />
          )}
          {preview && mainButton === MANAGE_VIEW_BUTTON && <ViewButton />}
          {(editable || isAdmin) && mainButton === MANAGE_EDIT_BUTTON && (
            <EditButton />
          )}
          {isShowMenu && (
            <Dropdown
              item
              icon="ellipsis horizontal"
              simple
              closeOnChange={true}
            >
              <Dropdown.Menu>
                {applicants &&
                  job.isInitialised &&
                  mainButton !== MANAGE_APPLICANTS_BUTTON && (
                    <ApplicantsButton isMenu={true} />
                  )}
                {stats &&
                  job.isInitialised &&
                  mainButton !== MANAGE_STATS_BUTTON && (
                    <StatsButton isMenu={true} />
                  )}
                {preview && <ViewButton isMenu={true} />}
                {(editable || isAdmin) && mainButton !== MANAGE_EDIT_BUTTON && (
                  <EditButton isMenu={true} />
                )}
                {repost && !isAdmin && mainButton !== MANGE_REPOSTS_BUTTON && (
                  <RepostButton isMenu={true} />
                )}
                {(deletable || isAdmin) && (
                  <Dropdown.Item>
                    <Button
                      className={"overwrite-button icon-text-button"}
                      content={"Delete"}
                      icon={
                        <img
                          className={"icon-text-button-img"}
                          src={trashHoverIcon}
                          style={{ width: 15, height: 15 }}
                          alt="delete"
                        />
                      }
                      onClick={() =>
                        dispatch(
                          openModal({
                            modalType: DELETE_JOB_CONFIRM_MODAL,
                            modalProps: { type, isAdmin, job },
                          })
                        )
                      }
                    />
                  </Dropdown.Item>
                )}
              </Dropdown.Menu>
            </Dropdown>
          )}
        </Grid.Column>
      </Grid>
    </div>
  );
}
